import Star from './Star';

Vue.component('icon-star', Star);
